import { memo } from "react";
import { KeyboardShortcut } from "../../../components/ui/keyboard-shortcut";
import { useCommandPalette } from "../../contexts/command-palette-context";
import { useMetaKey } from "../../hooks/use-meta-key";
import * as styles from "./command-palette-footer.module.css";

export interface CommandPaletteFooterProps {
  className?: string;
}

export const CommandPaletteFooter = memo(function CommandPaletteFooter({
  className,
}: CommandPaletteFooterProps) {
  const { actions } = useCommandPalette();
  const metaKey = useMetaKey();

  return (
    <div className={`${styles.container} ${className || ""}`}>
      <div className={styles.leftSection}>
        <div className={styles.shortcutGroup}>
          <KeyboardShortcut className={styles.shortcut} keys={["↑", "↓"]} />
          <span className={styles.actionText}>Select</span>
        </div>
        <div className={styles.shortcutGroup} onClick={actions.open}>
          <KeyboardShortcut className={styles.shortcut} keys={["↩"]} />
          <span className={styles.actionText}>Open</span>
        </div>
        <div className={styles.shortcutGroup} onClick={actions.openInNewTab}>
          <KeyboardShortcut className={styles.shortcut} keys={[metaKey, "↩"]} />
          <span className={styles.actionText}>Open in a new tab</span>
        </div>
      </div>
      <div className={styles.rightSection} />
    </div>
  );
});
